const breakpoint = 1024;
const header = document.querySelector('header');
const body = document.querySelector("body");

if(header) {
    const wrapperContent = header.querySelector('.wrapper').innerHTML;
    let headerHeight = header.offsetHeight;
    let lastScrollTop = 0;

    // Menu on scroll
    $(window).scroll(function (e) {
        let scrollTop = $(this).scrollTop();
        if ($(window).width() >= breakpoint && scrollTop <= 2) {
            header.classList.remove('sticky', 'show', 'animate');
        } 
        else if (scrollTop === 0) {
            header.classList.remove('sticky', 'show', 'animate');
        } 
        else if (scrollTop > headerHeight) {
            if (scrollTop < lastScrollTop) { // Scrolling up
                header.classList.add('sticky', 'animate', 'show')
            } else {
                header.classList.add('sticky');
                header.classList.remove('show');
            }
        }
        lastScrollTop = scrollTop;
    });

    setMobileNav();

    window.addEventListener('click', function(e) {
        if (!e.target.closest('.menu-content') && header.classList.contains('show-menu')) {
            document.querySelector("header .menu-content").classList.remove("anim");
            setTimeout(function() {
                document.querySelector("header .menu-content").classList.remove("show");
            }, 300);
            header.querySelector(".wrapper").classList.remove('anim');
            document.querySelector(".menu-button").classList.remove("menu-close");
            header.classList.remove('show-menu');
            body.classList.remove('no-scroll');
        }
      });

    function setMobileNav() {
        const button = document.querySelector(".menu-button");
        const navBar = document.querySelector("header .menu-content")
        const parent = document.querySelectorAll(".menu-item-has-children >a")
        const arrow = document.querySelectorAll(".menu-item-has-children >span")

        button.onclick = function toggleMenu() {
            if (navBar.matches('.show')) {
                navBar.classList.remove("anim");
                setTimeout(function() {
                    navBar.classList.remove("show");
                }, 300);
                header.querySelector(".wrapper").classList.remove('anim');
                button.classList.remove("menu-close");
                header.classList.remove('show-menu');
                body.classList.remove('no-scroll');
            }
            else {
                navBar.classList.add("show");
                setTimeout(function() {
                    navBar.classList.add("anim");
                }, 10);
                button.classList.add("menu-close");
                setTimeout(function() {
                    header.classList.add('show-menu');
                }, 300);
                header.querySelector(".wrapper").classList.add('anim');
                body.classList.add('no-scroll');

                // Hides dropdown when menu is hidden
                parent.forEach(function (ele) {
                    ele.classList.remove("show-ul");
                });
            }
        };

        if(window.innerWidth < breakpoint) {
            //dropdown
            /**
             * check if parent has child with classname
             * on click add or remove class
            */
            parent.forEach(function (ele) {
                ele.addEventListener('click', function(e) {
                    e.preventDefault();
                    if (ele.parentNode.classList.contains('show-ul')) {
                        window.location = e.target.href;
                    }
                    else {
                        ele.parentNode.classList.add("show-ul");
                    }
                });
            });
            arrow.forEach(function(ele) {
                ele.addEventListener('click', function(e) {
                    e.preventDefault();
                    if (ele.parentNode.classList.contains('show-ul')) {
                        ele.parentNode.classList.remove("show-ul");
                    }
                    else {
                        ele.parentNode.classList.add("show-ul");
                    }
                });
            });
        }
    }
}